// import React, { useState } from "react";
// import { Modal } from "react-bootstrap";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import {
//   ITProfessional,
//   RoundShape,
// } from "../Assets";
// import ezeemx from "../Assets/ezeemx.png";
// import ownerPortal from "../Assets/ownerPortal.png";
// import cgiImg from "../Assets/PowerFund_One-transparent.png";
// import resilink from "../Assets/Logo-transparent 5.png";
// import nextestify from "../Assets/nextestify.png";
// import projecthub from "../Assets/projecthub.png";
// import payroll from "../Assets/PayRoll.png";

// const ProductsPage = () => {
//   const [show, setShow] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState({
//     id: 0,
//     img: "",
//     date: "",
//     storyTopic: "",
//     storyContentShort: "",
//     storyContent: "",
//   });

//   const handleModal = (product) => {
//     setShow(true);
//     setSelectedProduct({
//       id: product.id,
//       imageSrc: product.imageSrc,
//       productName: product.productName,
//       productContent: product.productContent,
//     });
//   };

//   const products = [
//     // {
//     //   id: 1,
//     //   imageSrc: ITProfessional,
//     //   productName: "Owner Portal",
//     //   productContent:
//     //     "The Owner Portal is a dedicated platform designed to provide aircraft owners with real-time insights, operational control, and financial transparency for their aviation assets. It serves as a centralized hub for monitoring aircraft activity, managing maintenance schedules, accessing financial reports, and ensuring seamless communication with operators and service providers.",
//     // },
//     {
//       id: 2,
//       imageSrc: cgiImg,
//       productName: "CGI",
//       productContent:
//         "The CGI Application is a comprehensive platform designed to monitor solar energy generation, track customer consumption, and manage payment collections. It ensures seamless financial transactions between customers and installers, providing transparency and efficiency in the solar energy ecosystem.",
//     },
//     {
//       id: 3,
//       imageSrc: ownerPortal,
//       productName: "Customer Interactive",
//       productContent:
//         "Customer Interactive is a scripting application for managing inbound/outbound telemarketing and customer service. It enables users to create and edit scripts via MS Visio flowcharts with minimal technical knowledge. Built on open-source technology, it integrates seamlessly with hosted or on-premise call center systems.",
//     },
//     {
//       id: 4,
//       imageSrc: ezeemx,
//       productName: "eZeeMx",
//       productContent:
//         "This application simplifies and optimizes the entire lifecycle of aircraft maintenance services, from initial proposals to final execution. It empowers maintenance companies to generate comprehensive, customized proposals for clients, monitor and track service progress in real-time, and manage payments seamlessly, ensuring enhanced efficiency, transparency, and client satisfaction at every stage.",
//     },
//     {
//       id: 5,
//       imageSrc: resilink,
//       productName: "Resilink",
//       productContent:
//         "ResiLink is an integrated apartment and villa management system designed to digitize daily community operations. It replaces manual registers, spreadsheets, and informal communication channels with a centralized platform for billing, complaints, services, announcements, asset tracking, and resident engagement.",
//     },
//     {
//       id: 6,
//       imageSrc: nextestify,
//       productName: "Nextestify",
//       productContent:
//         "NexTestify is a powerful AI-driven online assessment platform designed to simplify and enhance the way tests, quizzes, and learning experiences are created and managed. It provides a complete solution for educators, organizations, and learners by combining intelligent question generation, secure exam environments, and detailed performance analytics in one place.",
//     },
//     {
//       id: 7,
//       imageSrc: projecthub,
//       productName: "Project Hub",
//       productContent:
//         "Project Hub is a centralized project management solution that enables teams to plan, track, and collaborate efficiently. It provides real-time insights, task management, and workflow automation to ensure timely project delivery.",
//     },
//     {
//       id: 8,
//       imageSrc: payroll,
//       productName: "Payroll",
//       productContent:
//         "Payroll is a comprehensive payroll management system that automates salary processing, tax calculations, and employee benefits. It ensures accuracy, compliance, and efficiency in managing employee compensation.",
//     },
//   ];

//   // FASTER slider settings - increased speed for faster transitions
//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 800,              // Increased from 500 to 800 for faster slide transitions
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,     // Reduced from 3000 to 2000 for faster autoplay (slides change quicker)
//     pauseOnHover: true,
//     arrows: true,
//     cssEase: "cubic-bezier(0.25, 0.46, 0.45, 0.94)", // Smoother, faster easing
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   const charlimit = 100;

//   return (
//     <div className="ml-services-area ptb-50" id="product-list">
//       <div className="container">
//         <div className="section-title text-center mb-5">
//           <span className="sub-title text-uppercase fw-semibold text-primary">Our Solutions</span>
//           <h2 className="display-6 fw-bold mt-2">Our Products</h2>
//           <div className="bar mx-auto my-3" style={{ width: "60px", height: "4px", background: "linear-gradient(90deg, #00e92b, #ccffa8)", borderRadius: "2px" }}></div>
//           <p className="text-muted fs-5">
//             Empowering businesses with technology-driven solutions for growth
//             and efficiency.
//           </p>
//         </div>

//         <Slider {...sliderSettings}>
//           {products.map((item) => (
//             <div className="px-3" key={item.id}>
//               <div className="single-ml-services-box bg-white rounded-4 shadow-sm p-4 text-center transition-all h-100" style={{ transition: "transform 0.3s ease, box-shadow 0.3s ease", cursor: "pointer", border: "1px solid rgba(0,0,0,0.05)" }}>
//                 <div className="image mb-3 d-flex justify-content-center align-items-center" style={{ height: "170px" }}>
//                   <img
//                     src={item.imageSrc}
//                     alt={item.productName}
//                     style={{ height: "150px", width: "auto", maxWidth: "100%", objectFit: "contain" }}
//                     className="img-fluid"
//                   />
//                 </div>
//                 <h3 className="h5 fw-bold mb-3">{item.productName}</h3>
//                 <p className="text-muted small" style={{ lineHeight: "1.6" }}>
//                   {item.productContent.length > charlimit
//                     ? `${item.productContent.slice(0, charlimit)}... `
//                     : item.productContent}
//                 </p>
//                 {item.productContent.length > charlimit && (
//                   <button
//                     className="read_more btn btn-link text-decoration-none fw-semibold mt-2 p-0"
//                     style={{ cursor: "pointer", background: "none", border: "none", color: "#00e92b" }}
//                     onClick={() => handleModal(item)}
//                   >
//                     Read More →
//                   </button>
//                 )}
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>

//       {/* Shape decorations */}
//       <div className="shape1">
//         <img src={RoundShape} alt="shape1" />
//       </div>
//       <div className="shape2 rotateme">
//         <img
//           src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
//           alt="shape"
//         />
//       </div>
//       <div className="shape3">
//         <img
//           src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
//           alt="shape"
//         />
//       </div>
//       <div className="shape4">
//         <img
//           src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
//           alt="shape"
//         />
//       </div>
//       <div className="shape7">
//         <img
//           src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
//           alt="shape"
//         />
//       </div>
//       <div className="shape8 rotateme">
//         <img
//           src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
//           alt="shape"
//         />
//       </div>

//       {/* Modal */}
//       <Modal show={show} onHide={() => setShow(false)} centered size="lg">
//         <div className="modal-content-custom border-0 rounded-4 overflow-hidden">
//           <Modal.Header closeButton className="modal-header-custom bg-light p-3 border-0">
//             {/* Optional title can go here */}
//           </Modal.Header>
//           <Modal.Body className="modal-body-custom p-4">
//             <div className="text-center mb-4">
//               <img
//                 src={selectedProduct.imageSrc}
//                 alt={selectedProduct.productName}
//                 className="modal-image rounded-3"
//                 style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }}
//               />
//             </div>
//             <h4 className="fw-bold mb-3">{selectedProduct.productName}</h4>
//             <p className="text-muted" style={{ lineHeight: "1.7" }}>{selectedProduct.productContent}</p>
//           </Modal.Body>
//         </div>
//       </Modal>

//       {/* Add some custom CSS for hover effects */}
//       <style jsx>{`
//         .single-ml-services-box:hover {
//           transform: translateY(-8px);
//           box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.15) !important;
//         }
//         .slick-prev:before, .slick-next:before {
//           color: #00e92b !important;
//           font-size: 24px !important;
//         }
//         .slick-dots li button:before {
//           font-size: 12px !important;
//           color: #00e92b !important;
//         }
//         .slick-dots li.slick-active button:before {
//           color: #00e92b !important;
//           opacity: 1 !important;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ProductsPage;
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  RoundShape,
} from "../Assets";
import ezeemx from "../Assets/ezeemx.png";
import ownerPortal from "../Assets/ownerPortal.png";
import cgiImg from "../Assets/PowerFund_One-transparent.png";
import resilink from "../Assets/Logo-transparent 5.png";
import nextestify from "../Assets/nextestify.png";
import projecthub from "../Assets/projecthub.png";
import payroll from "../Assets/PayRoll.png";


import { FaSolarPanel, FaUsers, FaPlane, FaBuilding, FaRobot, FaProjectDiagram, FaMoneyBillWave, FaTimes } from "react-icons/fa";
import { MdOutlinePayments } from "react-icons/md";
import { GiCommercialAirplane } from "react-icons/gi";
import { BiBuildingHouse } from "react-icons/bi";
import { IoSunny } from "react-icons/io5";

const ProductsPage = () => {
  const [show, setShow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    id: 0,
    img: "",
    date: "",
    storyTopic: "",
    storyContentShort: "",
    storyContent: "",
  });

  const handleModal = (product) => {
    setShow(true);
    setSelectedProduct({
      id: product.id,
      imageSrc: product.imageSrc,
      modalImage: product.modalImage,
      modalIcon: product.modalIcon,
      modalReactIcon: product.modalReactIcon, 
      productName: product.productName,
      productContent: product.productContent,
    });
  };

  const products = [
    {
      id: 2,
      imageSrc: cgiImg,
      modalIcon: "☀️",
      modalReactIcon: <FaSolarPanel size={50} color="#FFD700" />, 
      productName: "CGI",
      productContent:
        "The CGI Application is a comprehensive platform designed to monitor solar energy generation, track customer consumption, and manage payment collections. It ensures seamless financial transactions between customers and installers, providing transparency and efficiency in the solar energy ecosystem.",
    },
    {
      id: 3,
      imageSrc: ownerPortal,
      modalIcon: "👥",
      modalReactIcon: <FaUsers size={50} color="#4A90E2" />, 
      productName: "Customer Interactive",
      productContent:
        "Customer Interactive is a scripting application for managing inbound/outbound telemarketing and customer service. It enables users to create and edit scripts via MS Visio flowcharts with minimal technical knowledge. Built on open-source technology, it integrates seamlessly with hosted or on-premise call center systems.",
    },
    {
      id: 4,
      imageSrc: ezeemx,
      modalIcon: "✈️",
      modalReactIcon: <GiCommercialAirplane size={50} color="#E67E22" />, // React Icon for eZeeMx
      productName: "eZeeMx",
      productContent:
        "This application simplifies and optimizes the entire lifecycle of aircraft maintenance services, from initial proposals to final execution. It empowers maintenance companies to generate comprehensive, customized proposals for clients, monitor and track service progress in real-time, and manage payments seamlessly, ensuring enhanced efficiency, transparency, and client satisfaction at every stage.",
    },
    {
      id: 5,
      imageSrc: resilink,
      modalIcon: "🏢",
      modalReactIcon: <BiBuildingHouse size={50} color="#2ECC71" />, // React Icon for ResiLink
      productName: "Resilink",
      productContent:
        "ResiLink is an integrated apartment and villa management system designed to digitize daily community operations. It replaces manual registers, spreadsheets, and informal communication channels with a centralized platform for billing, complaints, services, announcements, asset tracking, and resident engagement.",
    },
    {
      id: 6,
      imageSrc: nextestify,
      modalIcon: "🤖",
      modalReactIcon: <FaRobot size={50} color="#9B59B6" />, // React Icon for Nextestify
      productName: "Nextestify",
      productContent:
        "NexTestify is a powerful AI-driven online assessment platform designed to simplify and enhance the way tests, quizzes, and learning experiences are created and managed. It provides a complete solution for educators, organizations, and learners by combining intelligent question generation, secure exam environments, and detailed performance analytics in one place.",
    },
    {
      id: 7,
      imageSrc: projecthub,
      modalIcon: "📊",
      modalReactIcon: <FaProjectDiagram size={50} color="#3498DB" />, // React Icon for Project Hub
      productName: "Project Hub",
      productContent:
        "Project Hub is a centralized project management solution that enables teams to plan, track, and collaborate efficiently. It provides real-time insights, task management, and workflow automation to ensure timely project delivery.",
    },
    {
      id: 8,
      imageSrc: payroll,
      modalIcon: "💰",
      modalReactIcon: <MdOutlinePayments size={50} color="#1ABC9C" />, // React Icon for Payroll
      productName: "Payroll",
      productContent:
        "Payroll is a comprehensive payroll management system that automates salary processing, tax calculations, and employee benefits. It ensures accuracy, compliance, and efficiency in managing employee compensation.",
    },
  ];

  // FASTER slider settings - increased speed for faster transitions
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: true,
    cssEase: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const charlimit = 100;

  return (
    <div className="ml-services-area ptb-50" id="product-list">
      <div className="container">
        <div className="section-title text-center mb-5">
          <span className="sub-title text-uppercase fw-semibold text-primary">Our Solutions</span>
          <h2 className="display-6 fw-bold mt-2">Our Products</h2>
          <div className="bar mx-auto my-3" style={{ width: "60px", height: "4px", background: "linear-gradient(90deg, #00e92b, #ccffa8)", borderRadius: "2px" }}></div>
          <p className="text-muted fs-5">
            Empowering businesses with technology-driven solutions for growth
            and efficiency.
          </p>
        </div>

        <Slider {...sliderSettings}>
          {products.map((item) => (
            <div className="px-3" key={item.id}>
              <div className="single-ml-services-box bg-white rounded-4 shadow-sm p-4 text-center transition-all h-100" style={{ transition: "transform 0.3s ease, box-shadow 0.3s ease", cursor: "pointer", border: "1px solid rgba(0,0,0,0.05)" }}>
                <div className="image mb-3 d-flex justify-content-center align-items-center" style={{ height: "170px" }}>
                  <img
                    src={item.imageSrc}
                    alt={item.productName}
                    style={{ height: "150px", width: "auto", maxWidth: "100%", objectFit: "contain" }}
                    className="img-fluid"
                  />
                </div>
                <h3 className="h5 fw-bold mb-3">{item.productName}</h3>
                <p className="text-muted small" style={{ lineHeight: "1.6" }}>
                  {item.productContent.length > charlimit
                    ? `${item.productContent.slice(0, charlimit)}... `
                    : item.productContent}
                </p>
                {item.productContent.length > charlimit && (
                  <button
                    className="read_more btn btn-link text-decoration-none fw-semibold mt-2 p-0"
                    style={{ cursor: "pointer", background: "none", border: "none", color: "#00e92b" }}
                    onClick={() => handleModal(item)}
                  >
                    Read More →
                  </button>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Shape decorations */}
      <div className="shape1">
        <img src={RoundShape} alt="shape1" />
      </div>
      <div className="shape2 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
      <div className="shape3">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
          alt="shape"
        />
      </div>
      <div className="shape4">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape7">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape8 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>

      {/* Modal with React Icons */}
      <Modal show={show} onHide={() => setShow(false)} centered size="lg">
        <div className="modal-content-custom border-0 rounded-4 overflow-hidden">
          <Modal.Header closeButton className="modal-header-custom bg-light p-3 border-0">
            {/* Optional title can go here */}
          </Modal.Header>
          <Modal.Body className="modal-body-custom p-4">
            <div className="text-center mb-4">
              {selectedProduct.modalReactIcon ? (
                <div 
                  className="modal-icon rounded-3 d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "120px",
                    height: "120px",
                    marginBottom: "10px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  {selectedProduct.modalReactIcon}
                </div>
              ) : selectedProduct.modalIcon ? (
                <div 
                  className="modal-icon rounded-3 d-flex align-items-center justify-content-center mx-auto"
                  style={{
                    width: "120px",
                    height: "120px",
                    fontSize: "60px",
                    marginBottom: "10px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  {selectedProduct.modalIcon}
                </div>
              ) : (
                <img
                  src={selectedProduct.imageSrc}
                  alt={selectedProduct.productName}
                  className="modal-image rounded-3"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    marginBottom: "10px"
                  }}
                />
              )}
            </div>
            <h4 className="fw-bold mb-3 text-center">{selectedProduct.productName}</h4>
            <p className="text-muted" style={{ lineHeight: "1.7" }}>{selectedProduct.productContent}</p>
          </Modal.Body>
        </div>
      </Modal>

      {/* Add some custom CSS for hover effects */}
      <style jsx>{`
        .single-ml-services-box:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.15) !important;
        }
        .slick-prev:before, .slick-next:before {
          color: #00e92b !important;
          font-size: 24px !important;
        }
        .slick-dots li button:before {
          font-size: 12px !important;
          color: #00e92b !important;
        }
        .slick-dots li.slick-active button:before {
          color: #00e92b !important;
          opacity: 1 !important;
        }
      `}</style>
    </div>
  );
};

export default ProductsPage;